
import { ParallaxContext } from '@/render/parallax/ParallaxEffect';

export abstract class BaseParallaxEffect {
    protected pseudoRandom(s: number) {
        const x = Math.sin(s) * 10000;
        return x - Math.floor(x);
    }

    protected getGridBounds(pc: ParallaxContext, spacing: number) {
        const { width, height } = pc;
        const buffer = 1000;
        return {
            x1: Math.floor((-width - buffer) / spacing) * spacing,
            x2: Math.ceil((width + buffer) / spacing) * spacing,
            y1: Math.floor((-height - buffer) / spacing) * spacing,
            y2: Math.ceil((height + buffer) / spacing) * spacing
        };
    }

    protected applyGlow(pc: ParallaxContext, drawCall: () => void) {
        const { ctx, config, color } = pc;
        if (config.parallaxGlowEnabled) {
            ctx.save();
            ctx.shadowBlur = config.parallaxGlowRadius || 10;
            ctx.shadowColor = color;
            ctx.globalAlpha *= config.parallaxGlowOpacity || 0.5;
            drawCall();
            ctx.restore();
        }
    }
}
